export const GET_FILTERS = 'GET_CREDIT_FLOW_RESEARCH_FILTERS';
export const GET_FILTERS_SUCCESS = 'GET_CREDIT_FLOW_RESEARCH_FILTERS_SUCCESS';
export const GET_FILTERS_ERROR = 'GET_CREDIT_FLOW_RESEARCH_FILTERS_ERROR';

export const FILTER_PAYLOAD = 'CREDIT_FLOW_RESEARCH_FILTER_PAYLOAD';
export const FILTER_APPLY = 'CREDIT_FLOW_RESEARCH_FILTER_APPLY';
export const INITIAL_FILTERS = 'CREDIT_FLOW_RESEARCH_INITIAL_FILTERS';

export const FILTER_MIN_DATE_FROM = 'CREDIT_FLOW_FILTER_MIN_DATE_FROM';
export const FILTER_MAX_DATE_TO = 'CREDIT_FLOW_FILTER_MAX_DATE_TO';

export const RESET_FILTERS = 'RESET_CREDIT_FLOW_RESEARCH_FILTERS';
export const RESET_FILTER_MIN_MAX_DATE = 'CREDIT_FLOW_RESET_FILTER_MIN_MAX_DATE';
